"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useFlows(query) {
  const { ...rest } = useElements("flows", query);
  return {
    flows: rest.items,
    ...rest
  };
}

export { useFlows };
